import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from '../components/Footer';

const General = () => {
  return (
    <>
      <nav aria-label="breadcrumb" className="mt-5 d-flex justify-content-center">
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item">
            <a href="/">Home</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            General Insurance
          </li>
        </ol>
      </nav><br />

      {/* Hero Section */}
      <div className="container my-4">
        <div className="row align-items-center g-4">
          <div className="col-lg-6">
            <h1 className="display-5 fw-bold text-primary mb-3">
              Become a General Insurance Agent
            </h1>
            <p className="lead text-muted mb-4">
              Join India's fastest-growing general insurance distribution network
            </p>
            <div className="mb-4">
              <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill me-2">
                🚀 ₹1.5 Lakh Crore Market
              </span>
              <span className="badge bg-success bg-opacity-10 text-success px-3 py-2 rounded-pill">
                💰 High Earning Potential
              </span>
            </div>
            <p className="mb-3" style={{ textAlign: 'justify', lineHeight: '1.8' }}>
              At <strong>Agency Bazaar</strong>, we connect aspiring insurance professionals with 
              India's leading general insurance companies. A <strong>General Insurance Agent</strong> 
              specializes in non-life insurance products including health, motor, home, travel, 
              and business insurance, helping clients protect their assets and health.
            </p>
          </div>
          <div className="col-lg-6">
            <div className="bg-light rounded-4 p-4 text-center shadow-sm">
              <div className="display-1 mb-3">🛡️</div>
              <h4 className="text-primary">Join as a General Insurance Agent</h4>
              <p className="text-muted">Build a rewarding career with unlimited income potential</p>
            </div>
          </div>
        </div>
      </div>

      {/* What is a General Insurance Agent Section */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">What is a <span className="text-dark">General Insurance Agent?</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="p-4 shadow-sm rounded-4 bg-white">
              <p className="mb-3" style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>
                A <strong>General Insurance Agent</strong> is an <strong>IRDAI-licensed professional</strong> who specializes in <strong>non-life insurance products</strong>. 
                Unlike life insurance which covers death, general insurance covers losses from unexpected events. Their primary role includes:
              </p>
              <ul style={{ fontSize: '1rem', lineHeight: '1.8' }}>
                <li>🏥 <strong>Health Insurance</strong> - Medical expenses, hospitalization, critical illness coverage</li>
                <li>🚗 <strong>Motor Insurance</strong> - Car, bike, and commercial vehicle protection</li>
                <li>🏠 <strong>Home Insurance</strong> - Property protection against natural calamities, theft, fire</li>
                <li>✈️ <strong>Travel Insurance</strong> - Trip cancellations, medical emergencies abroad</li>
                <li>🏢 <strong>Business Insurance</strong> - Liability, property, and commercial coverage</li>
                <li>🌾 <strong>Crop Insurance</strong> - Farmers' protection against crop failure</li>
              </ul>
              <div className="alert alert-primary mt-3">
                <strong>📊 Market Opportunity:</strong> India's general insurance market is <strong>₹1.45-1.55 Lakh Crore</strong> with <strong>15-17% annual growth</strong>. The sector needs millions of agents to penetrate Tier 2/3 cities!
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Benefits of Joining as General Insurance Agent */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">Benefits of Joining as <span className="text-dark">General Insurance Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
          <p className="text-muted mt-3">Why general insurance is a lucrative career choice</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">💰</div>
              <h5 className="fw-bold">High Commission Structure</h5>
              <p className="text-muted">Earn 10-25% commission on health, 15-20% on motor, and up to 30% on commercial policies.</p>
              <small className="text-primary">Higher premiums = Higher commissions</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">🔄</div>
              <h5 className="fw-bold">Annual Renewal Income</h5>
              <p className="text-muted">Unlike life insurance, general insurance renews EVERY year. Earn recurring commissions annually!</p>
              <small className="text-primary">Passive income year after year</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">📊</div>
              <h5 className="fw-bold">Growing Market Demand</h5>
              <p className="text-muted">Health awareness, vehicle sales, and travel are booming. More people need general insurance daily.</p>
              <small className="text-primary">15-17% industry growth rate</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">📚</div>
              <h5 className="fw-bold">Free Training & Certification</h5>
              <p className="text-muted">IRDAI-approved training for IC-38 exam. No cost for licensing support.</p>
              <small className="text-primary">Become certified quickly</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">⏰</div>
              <h5 className="fw-bold">Flexible Working Hours</h5>
              <p className="text-muted">Work full-time or part-time. Perfect for students, homemakers, and retirees.</p>
              <small className="text-primary">Be your own boss</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">🏆</div>
              <h5 className="fw-bold">Incentives & Recognition</h5>
              <p className="text-muted">Foreign trips, bonuses, awards, and career growth to Development Officer.</p>
              <small className="text-primary">Performance-based rewards</small>
            </div>
          </div>
        </div>
      </div>

      {/* How to Work as General Insurance Agent */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">How to Work as <span className="text-dark">General Insurance Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
          <p className="text-muted mt-3">Simple steps to start your general insurance career</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                1
              </div>
              <h5 className="fw-bold">Complete IRDAI Training</h5>
              <p className="text-muted">Enroll in 50-hour compulsory training from an IRDAI-approved institute (online/offline).</p>
              <small className="text-primary">Duration: 2-3 weeks</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                2
              </div>
              <h5 className="fw-bold">Pass IC-38 Exam</h5>
              <p className="text-muted">Clear IRDAI's IC-38 examination to get your general insurance agent license.</p>
              <small className="text-primary">Exam conducted online</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                3
              </div>
              <h5 className="fw-bold">Get Appointed with Insurers</h5>
              <p className="text-muted">Agency Bazaar connects you with 30+ general insurance companies for appointment.</p>
              <small className="text-primary">Health, Motor, Home insurers</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                4
              </div>
              <h5 className="fw-bold">Build Client Network</h5>
              <p className="text-muted">Start with family, friends, neighbors. Target vehicle owners, families, small businesses.</p>
              <small className="text-primary">Unlimited market potential</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                5
              </div>
              <h5 className="fw-bold">Sell & Earn Commissions</h5>
              <p className="text-muted">Earn upfront commissions + annual renewals. Higher premiums = higher earnings.</p>
              <small className="text-primary">10-30% commission rates</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                💡
              </div>
              <h5 className="fw-bold">Daily Work Activities</h5>
              <p className="text-muted">• Client meetings (10-15 daily)<br/>• Policy renewals reminders<br/>• Claim assistance<br/>• Cross-selling opportunities</p>
              <small className="text-primary">Repeat business every year</small>
            </div>
          </div>
        </div>
      </div>

      {/* Types of General Insurance Plans Agents Sell */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">General Insurance Plans <span className="text-dark">You'll Sell as an Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
          <p className="text-muted mt-3">Diverse products with high demand across India</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">🏥</div>
                <h5 className="card-title fw-bold">Health Insurance</h5>
                <p className="card-text text-muted small">Individual, family floater, critical illness, senior citizen plans.</p>
                <small className="text-primary">Commission: 10-25% | High demand</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">🚗</div>
                <h5 className="card-title fw-bold">Car Insurance</h5>
                <p className="card-text text-muted small">Comprehensive, third-party, zero depreciation, NCB benefits.</p>
                <small className="text-primary">Commission: 15-20% | Mandatory by law</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">🏍️</div>
                <h5 className="card-title fw-bold">Bike Insurance</h5>
                <p className="card-text text-muted small">Two-wheeler insurance with roadside assistance and personal accident cover.</p>
                <small className="text-primary">High volume | Easy to sell</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">🏠</div>
                <h5 className="card-title fw-bold">Home Insurance</h5>
                <p className="card-text text-muted small">Structure, content, burglary, natural disaster coverage.</p>
                <small className="text-primary">Growing awareness | Good commissions</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">✈️</div>
                <h5 className="card-title fw-bold">Travel Insurance</h5>
                <p className="card-text text-muted small">International and domestic travel, trip cancellation, medical abroad.</p>
                <small className="text-primary">High margins | Seasonal demand</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">🏢</div>
                <h5 className="card-title fw-bold">Commercial Insurance</h5>
                <p className="card-text text-muted small">Shop, office, factory, liability, marine, fire, burglary coverage.</p>
                <small className="text-primary">High premiums | Up to 30% commission</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why General Insurance is a Great Career */}
      <div className="container my-5">
        <div className="bg-light rounded-4 p-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold text-primary">Why General Insurance is a <span className="text-dark">Great Career Choice</span></h2>
            <div className="d-flex justify-content-center">
              <div style={{
                width: '60px',
                height: '3px',
                backgroundColor: '#0d6efd',
                borderRadius: '2px'
              }}></div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mb-3">
              <div className="text-center p-3">
                <div className="fs-2 mb-2">📈</div>
                <h6 className="fw-bold">15-17% Annual Growth</h6>
                <p className="small text-muted">Industry growing faster than ever</p>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="text-center p-3">
                <div className="fs-2 mb-2">🔄</div>
                <h6 className="fw-bold">100% Renewal Business</h6>
                <p className="small text-muted">Every policy renews annually</p>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="text-center p-3">
                <div className="fs-2 mb-2">🎯</div>
                <h6 className="fw-bold">Massive Untapped Market</h6>
                <p className="small text-muted">70% of India still uninsured</p>
              </div>
            </div>
          </div>
          <div className="alert alert-success mt-3">
            <strong>💡 Key Insight:</strong> Unlike life insurance (one-time sale with renewals), general insurance products NEED to be renewed EVERY YEAR. This means once you build a client base, you earn recurring commissions annually without additional effort!
          </div>
        </div>
      </div>

      {/* Skills Required for Success */}
      <div className="container my-5">
        <div className="card border-0 shadow-sm rounded-4 bg-white">
          <div className="card-body p-4">
            <h3 className="fw-bold text-primary mb-4 text-center">Skills Required to Succeed</h3>
            <div className="row">
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="mb-3">✅ <strong>Communication & Trust Building</strong> - Clients buy from people they trust</li>
                  <li className="mb-3">✅ <strong>Basic Product Knowledge</strong> - Understand health, motor, home insurance</li>
                  <li className="mb-3">✅ <strong>Networking Ability</strong> - Connect with vehicle dealers, hospitals, real estate agents</li>
                  <li className="mb-3">✅ <strong>Digital Literacy</strong> - Use apps, social media for lead generation</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="mb-3">✅ <strong>Negotiation Skills</strong> - Help clients choose right coverage within budget</li>
                  <li className="mb-3">✅ <strong>Perseverance</strong> - Follow-ups lead to sales and renewals</li>
                  <li className="mb-3">✅ <strong>Organization</strong> - Track renewal dates and client documents</li>
                  <li className="mb-3">✅ <strong>Empathy</strong> - Understand client needs, especially during claims</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container my-5">
        <div className="bg-primary text-white rounded-4 p-5 text-center"
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.02)';
              e.currentTarget.style.transition = 'all 0.3s ease';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}>
          <h2 className="fw-bold mb-3">Ready to Start Your Career as General Insurance Agent?</h2>
          <p className="mb-4">Join Agency Bazaar today! Get free training, licensing support, and appointment with 30+ top insurers.</p>
          <button
            className="btn btn-light btn-lg px-5 rounded-pill text-primary fw-bold"
            style={{ transition: 'all 0.3s ease' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.backgroundColor = '#f8f9fa';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            Register as General Insurance Agent Now →
          </button>
          <p className="mt-3 small opacity-75">Limited slots available. Apply today!</p>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default General;


